"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var TreeNothingFound = /*#__PURE__*/_react.default.memo(function () {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "TreeTreeNothingFound display-flex justify-content-center text-size-20\n                padding-top-25 margin-top-25 margin-bottom-25"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-looking-glass-man text-size-400pct text-color-light'
  }));
});

TreeNothingFound.displayName = 'TreeNothingFound';
TreeNothingFound.defaultProps = {};
TreeNothingFound.propTypes = {
  value: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = TreeNothingFound;
exports.default = _default;